/* Home page seat projection bar */
(function () {
    var roots = document.querySelectorAll('[data-ukpr-results-home-widget]');
    if (!roots.length) return;

    var partyMeta = {
        reform: {label: 'REFORM', color: '#26C6DA', textColor: '#1d1d1d'},
        lab: {label: 'LAB', color: '#FF1744', textColor: '#ffffff'},
        con: {label: 'CON', color: '#1E88E5', textColor: '#ffffff'},
        lib: {label: 'LD', color: '#F6A800', textColor: '#1d1d1d'},
        snp: {label: 'SNP', color: '#F2D232', textColor: '#1d1d1d'},
        green: {label: 'GRN', color: '#5AD313', textColor: '#1d1d1d'},
        other: {label: 'OTHER', color: '#BDBDBD', textColor: '#1d1d1d'}
    };

    function toSeatRows(parties) {
        var rows = Object.keys(parties || {}).map(function (key) {
            var item = parties[key] || {};
            var block = item.seats || {};
            return {
                key: key,
                prediction: Number(block.prediction || 0),
                meta: partyMeta[key] || {label: key.toUpperCase(), color: '#9E9E9E', textColor: '#1d1d1d'}
            };
        });
        rows.sort(function (a, b) {
            return b.prediction - a.prediction;
        });
        return rows;
    }

    function render(root, rows) {
        var track = root.querySelector('[data-results-home-track]');
        if (!rows.length) {
            track.innerHTML = '<p class="ukpr-results-home-status">No result data available.</p>';
            return;
        }

        var totalSeats = 650;
        track.innerHTML = rows.map(function (row) {
            var width = Math.max((row.prediction / totalSeats) * 100, 0);
            var label = row.prediction >= 40
                ? '<span class="ukpr-results-home-seg-label" style="color:' + row.meta.textColor + '">' + row.meta.label + ' ' + row.prediction + '</span>'
                : '';
            return '<div class="ukpr-results-home-segment" style="width:' + width.toFixed(4) + '%;background:' + row.meta.color + ';">' + label + '</div>';
        }).join('');
    }

    function animateIn(root) {
        var track = root.querySelector('[data-results-home-track]');
        if (!track) return;

        track.classList.remove('is-revealing');
        void track.offsetWidth;
        track.classList.add('is-revealing');
    }

    function init(root) {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        fetch('https://pollingreport.uk/api/v1/results?consolidated=true&latest=true&model=uniform&legacy=false', {credentials: 'omit'})
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function (payload) {
                var parties = payload && payload.data && payload.data.parties;
                render(root, toSeatRows(parties));
                animateIn(root);
            })
            .catch(function () {
                var track = root.querySelector('[data-results-home-track]');
                track.innerHTML = '<p class="ukpr-results-home-status">Latest model unavailable.</p>';
            });
    }

    roots.forEach(init);
})();
